export default "__VITE_ASSET__BPkC2HaT__"